import { Button } from "@/components/ui/button";
import { ArrowRight, MapPin, Truck, Users } from "lucide-react";

import { Link } from "react-router-dom";
import ImageSvg from "../ui/image-svg";

export const RedeNacionalSection = () => {
  return (
    <section className="py-10 md:py-24 bg-white">
      <div className="container">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="mb-5 text-n-text-green text-3xl font-semibold md:mb-6 md:text-[40px] ">
              A maior rede de apoio para transporte de veículos em todo o país
            </h2>
            <p className="md:text-lg text-n-text-neutral mb-6">
              Com <strong>4 bases próprias em expansão</strong> e mais de{" "}
              <strong>200 bases parceiras ativas</strong> nas principais e mais
              estratégicas cidades do Brasil, garantimos capilaridade real.
              <br />
              Oferecemos a <strong>
                melhor logística e a menor distância
              </strong>{" "}
              para coleta ou entrega do seu veículo..
            </p>

            <div className="grid grid-cols-3 md:grid-cols-3 gap-6 mb-8">
              <div className="text-center">
                <MapPin className="h-8 w-8 text-n-text-green mx-auto mb-2" />
                <div className="text-2xl font-bold text-n-text-green">200+</div>
                <div className="text-md text-n-text">Pontos de Apoio</div>
              </div>
              <div className="text-center">
                <Users className="h-8 w-8 text-n-text-green mx-auto mb-2" />
                <div className="text-2xl font-bold text-n-text-green">500+</div>
                <div className="text-md text-n-text">Transportadoras</div>
              </div>
              <div className="text-center">
                <Truck className="h-8 w-8 text-n-text-green mx-auto mb-2" />
                <div className="text-2xl font-bold text-n-text-green">
                  1000+
                </div>
                <div className="text-md text-n-text">Veículos/Mês</div>
              </div>
            </div>

            <Link to="/fazer-cotacao">
              <Button>
                Agendar meu transporte
                <ArrowRight className=" h-6 w-6" />
              </Button>
            </Link>
          </div>

          <div className="flex items-center justify-center">
            <ImageSvg
              src="mais-de-200-bases-no-brasil.svg"
              alt="Rede nacional de pontos de apoio"
              className="w-[70%] h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
